<template>
    <div style="min-height: 80vh" class="mb-15">
        <div class="mb-6">

            <div v-if="$route.params.contentType === 'CPC'" class="title py-3 px-4 title-div" style="font-family: 'Mv Eamaan XP' !important;">
                <p class="caption mb-0">
                    <a href="#/" class="grey--text text--lighten-2">ފުރަތަމަ ސަފްޙާ / </a>
                    <a class="grey--text text--lighten-2">{{getTitle($route.params.category, 'category')}} / </a>
                    <a :href="`#/${$route.params.category}/${$route.params.contentType}`" class="grey--text text--lighten-2">މަދަނީ އިޖުރާއަތުގެ ބިލު</a>
                </p>
                މަދަނީ އިޖުރާއަތުގެ ބިލު
            </div>
            <div v-else class="eamaan py-3 px-4 title-div">
                <p class="caption">
                    <a href="#/" class="grey--text text--lighten-2">ފުރަތަމަ ސަފްޙާ / </a><a class="grey--text text--lighten-2">{{getTitle($route.params.category, 'category')}}</a>
                </p>
                {{$route.params.contentType === 'Attorney General' ? contentItem[0].Title : getTitle($route.params.contentType)}}
            </div>
            <v-progress-linear
            v-if="loadingPage"
            indeterminate
            color="primary"
            ></v-progress-linear>
        </div>
        <v-row class="px-4">
            <v-col md="3" class="pr-0 hidden-sm-and-down">
                <div class="elevation-1">
                <div
                v-for="(value, key) in navItems"
                :key="key"
                >
                    <v-list-group
                    dense
                    :value="$route.params.category === value.eng ? true : false"
                    >
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title class="px-0 eamaan">{{value.dhi}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item
                        v-for="(n, indexSub) in value.subItems"
                        :key="n.eng"
                        dense
                        @click="() => {}"
                        link
                        :href="n.eng === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n.eng === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' :  `#/${value.eng}/${n.eng}`"
                        >
                            <v-list-item-title class="px-1 font-weight-light" :class="$route.params.contentType === n.eng ? 'info--text' : ''">{{n.dhi}}</v-list-item-title>
                            <v-divider></v-divider>
                        </v-list-item>
                    </v-list-group>
                    <v-divider></v-divider>
                </div>
                </div>
            </v-col>
            <v-col cols="11" sm="11" md="8" id="printdiv">
                <div v-if="!loadingPage">
                    <p v-if="$route.params.contentType === 'CPC'" class="display-1 primary--text mb-10" style="font-family: 'Mv Eamaan XP' !important;">މަދަނީ އިޖުރާއަތުގެ ބިލު</p>
                    <p class="display-1 primary--text mb-10" style="font-family: 'Mv Eamaan XP' !important;">{{ $route.params.contentType === 'Attorney General' ? contentItem[0].Title : getTitle($route.params.contentType)}}</p>

                    <!-- <iframe class="mb-5" v-if="$route.params.contentType === 'Contact Us'" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15916.858192193517!2d73.5129926!3d4.1781834!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2da8508cd9343f51!2sAttorney%20General&#39;s%20Office!5e0!3m2!1sen!2smv!4v1598904450210!5m2!1sen!2smv" width="100%" height="250" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> -->
                    <div v-if="contentItem.length <= 1 && contentItem.length > 0 && $route.params.contentType !== 'Organization Structure' && $route.params.contentType !== 'Constitution' && $route.params.contentType !== 'Meet our Interns' && $route.params.contentType !== 'Contact Us' && !$route.query.page">
                        <div class="mb-10" v-if="$route.params.contentType === 'Awareness'">
                            <p>ދިވެހިރާއްޖޭގެ ލީގަލް އެއިޑްގެ ނިޒާމާ ގުޅޭގޮތުން އެޓަރނީ ޖެނެރަލްގެ އޮފީހުން 11 އޮގަސްޓު 2021 ގައި 4 ވަނަ "ޕްރޯ ބޯނޯ ކޮންފަރެންސް އޮން ލީގަލް އެއިޑް" އަށް ހުށަހެޅި ޕްރެޒެންޓޭޝަން މި <a href="./files/LEGAL AID STRUCTURE - MALDIVES - AGO.pdf">ލިންކް</a> އިން ލިބިވަޑައިގަންނަވާނެއެވެ.</p>
                            <div style="direction: ltr;">
                                <v-carousel
                                hide-delimiters
                                next-icon="mdi-chevron-left"
                                prev-icon="mdi-chevron-right"
                                style="direction: ltr !important;"
                                height="auto"
                                >
                                    <v-carousel-item
                                        v-for="(i) in numPages"
                                        :key="i"
                                    >
                                        <pdf
                                            :src="src"
                                            :page="i"
                                        ></pdf>
                                    </v-carousel-item>
                                </v-carousel>
                            </div>
                        </div>
                        <single-content :contents="contentItem" v-if="!agProfile && $route.params.contentType !== 'Attorney General'"></single-content>
                        <ag-profile :contents="contentItem" v-if="$route.params.contentType === 'Attorney General'"></ag-profile>
                    </div>
                    <div v-else-if="(contentItem.length > 1 || ( contentItem.length == 1 &&  $route.query.page > 1)) && $route.params.contentType !== 'Senior Management' &&  $route.params.contentType !== 'Former Attorneys General' &&  $route.params.contentType !== 'Meet our Colleagues' && $route.params.contentType !== 'Meet our Interns' && $route.params.contentType !== 'Visits'">
                        <item-list :contents="contentItem"></item-list>
                    </div>
                    <div v-else-if="$route.params.contentType === 'Meet our Colleagues' || $route.params.contentType === 'Meet our Interns'">
                        <colleagues :contents="contentItem"></colleagues>
                    </div>
                    <div v-else-if="$route.params.contentType === 'Visits'">
                        <visits :totalRows="totalRows" :page="page" :numberOfPages="numberOfPages" :contents="contentItem"></visits>
                    </div>
                    <div v-else-if="$route.params.contentType == 'Organization Structure'">
                        <structure :contents="contentItem"></structure>
                    </div>
                    <div v-else-if="$route.params.contentType === 'Former Attorneys General'">
                        <former-attorneys :contents="contentItem"></former-attorneys>
                    </div>
                    <div v-else-if="$route.params.contentType == 'Contact Us'">
                        <contact-us :contents="contentItem"></contact-us>
                    </div>
                    <div v-else-if="$route.params.contentType == 'Senior Management'">
                        <management :contents="contentItem"></management>
                    </div>
                    
                    <div v-else>
                        <p class="title" v-if="$route.params.contentType === 'Career opportunities'" style="font-family: 'Mv Eamaan XP' !important;"> މިވަގުތު މި އޮފީހުގައި ވަޒީފާގެ ފުރުޞަތެއް ނެތެވެ.</p>
                        <p class="title" v-else  style="font-family: 'Mv Eamaan XP' !important;">ހޯއްދަވަން އުޅުއްވި ސަފުހާ ނުފެނުނު!</p>
                    </div>
                    <v-pagination class="my-5 elevation-0" v-if="totalRows > 20" :total-visible="7" v-model="page" :length="numberOfPages"></v-pagination>

                    <highcharts  v-if="chartAvailability($route.params.contentType)" :options="chartOptions.chartData" ref="summaryChart"></highcharts>
                </div>
            </v-col>
            <v-col cols="1" sm="1">
                <div class="sticky text-left">
                    <v-btn icon class="my-2" @click="printPage()" color="grey lighten-1">
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                    <br>
                    <v-btn :href="`http://www.facebook.com/sharer.php?u=${currentUrl}`" target="_blank" icon class="my-2" color="grey lighten-1">
                        <v-icon>mdi-facebook</v-icon>
                    </v-btn>
                    <br>
                    <v-btn :href="`https://twitter.com/intent/tweet?url=${currentUrl}`" icon class="my-2" target="_blank" color="grey lighten-1">
                        <v-icon>mdi-twitter</v-icon>
                    </v-btn>
                    <br>
                    <v-btn href="mailTo:info@agoffice.gov.mv" icon class="my-2" target="_blank" color="grey lighten-1">
                        <v-icon>mdi-email</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { Chart } from 'highcharts-vue'
import ItemList from '../components/ItemList.vue'
import SingleContent from '../components/SingleContent.vue'
import FormerAttorneys from '../components/FormerAttorneys.vue'
import Management from '../components/Management'
import AgProfile from '../components/AgProfile'
import Colleagues from '../components/Colleagues'
import ContactUs from '../components/ContactUs.vue'
import Visits from '../components/Visits'
import Structure from '../components/Structure'
import pdf from 'vue-pdf'
var loadingTask = pdf.createLoadingTask('./files/LEGAL AID STRUCTURE - MALDIVES - AGO.pdf')
export default {
    name: 'Content',
    metaInfo: () => ({
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: this.agProfile ? this.$route.params.contentType : this.getTitle($route.params.contentType)
    }),
    props: ['navItems'],
    data: () => ({
        contentItem: [],
        agProfile: false,
        loadingPage: true,
        src: loadingTask,
        numPages: undefined,
        currentPage: 1,
        pageCount: 0,
        currentUrl: 'window.location.href',
        totalRows: 0,
        numberOfPages: 0,
        page: 1,
        chartOptions: {}
    }),
    components: {
        pdf,
        'item-list': ItemList,
        'single-content': SingleContent,
        'former-attorneys': FormerAttorneys,
        'management' : Management,
        'ag-profile' : AgProfile,
        'colleagues' : Colleagues,
        'visits' : Visits,
        'structure' : Structure,
        'contact-us' : ContactUs,
        highcharts: Chart
    },
    watch: {
        page (val) {
            this.$router.push({query: {page: val}}).catch(()=>{});
            this.getData()
        }
    },
    created() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.async = true
        recaptchaScript.src = 'https://platform.twitter.com/widgets.js'
        document.head.appendChild(recaptchaScript)
        
        this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
        // this.$activeTab = '$route.params.category'
        this.getData()
        this.$http.get('./Charts.json?v=2').then((response) => {
            // console.log(response.data)
            this.chartOptions = response.data
        })
        this.src.promise.then(pdf => {
		    this.numPages = pdf.numPages;
		})
    },
    methods: {
        getData() {
            this.$http.get(`${this.$url}/pagination/1/${this.$route.params.category}/${this.$route.params.contentType}?limit=21&page=${this.page-1}&sort=${this.$route.params.contentType === 'Former Attorneys General' ? 'id%20desc' : this.$route.params.contentType === 'Meet our Colleagues' ? 'content_order' : 'date%20desc'}`).then((response)=>{
                this.contentItem = response.data.data.rows
                this.totalRows = response.data.data.total_rows
                this.numberOfPages = Math.ceil(response.data.data.total_rows / 21)
                this.loadingPage = false
                console.log(this.$route.params.category, this.contentItem.length)
                if (this.$route.params.category == 'Attorney General' && this.contentItem.length <= 0) {
                    this.$http.get(`${this.$url}/pagination/1/${this.$route.params.category}?limit=20&page=0&title.contains=${this.$route.params.contentType}&sort=id%20desc`).then((response)=>{
                        
                        this.contentItem = response.data.data.rows
                        if (this.contentItem.length > 0) {
                            this.agProfile = true
                        }
                        this.loadingPage = false
                    })
                }
            }).catch(err => {
                this.$http.get(`${this.$url}/pagination/1/${this.$route.params.category}?limit=20&page=0&title.contains=${this.$route.params.contentType}&sort=id%20desc`).then((response)=>{
                    
                    this.contentItem = response.data.data.rows
                    if (this.contentItem.length > 0) {
                        this.agProfile = true
                    }
                    this.loadingPage = false
                })
            })
        },
        getImage(item) {
                // console.log('item.Files')
            if (item.Files && item.Files.length > 0) {
                let images = item.Files.filter(obj => obj.FileType.includes('image'))
                if (images.length > 0) {
                return `${this.$url}/downloadfile/${images[0].ID}`
                }
                else {
                return ''
                }
            }
            else {
                return ''
            }
        },
        getReversed(items) {
            return items.reverse()
        },
        printPage() {
            // Get HTML to print from element
            const prtHtml = document.getElementById('printdiv').innerHTML;

            // Get all stylesheets HTML
            let stylesHtml = '';
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
            }

            // Open the print window
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

            WinPrint.document.write(`<!DOCTYPE html>
            <html>
            <head>
                ${stylesHtml}
            </head>
            <body>
                ${prtHtml}
            </body>
            </html>`);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();
            WinPrint.close();
            // window.print()
        },
        getTitle (title, type) {
            let foo = ''
            if (type === 'category') {
                for(let item of this.navItems) {
                    if (item.eng === title) {
                        foo = item.dhi
                        break
                    }
                }
            } else {
                for(let item of this.navItems) {
                    for (let sub of item.subItems) {
                        // if (sub.eng.includes(title)) {
                        //     foo = sub.dhi
                        //     break
                        // }
                        if (sub.eng.toUpperCase() === title.toUpperCase()) {
                            foo = sub.dhi
                            break
                        }
                    }
                }
            }
            return foo
        },
        chartAvailability (page) {
            return this.chartOptions.pgae === page
        }
    }
}
</script>
<style>
.ql-editor {
    padding: 0
}
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
@media print {
img {
        opacity: 0.3;
        position: absolute;
        left: 2%;
        top: 100px;
    }
}
.v-application--is-rtl .v-window__prev {
    left: 0;
    right: unset;
}
.v-application--is-rtl .v-window__next {
    right: 0;
    left: unset;
}
table {
    width: 100% !important;
}
/* td {
    border-style: solid !important;
    border-width: 1px 1px 1px 1px !important;
    border-color: #000000 #000000 #000000 #000000 !important;
    padding: 0px 7.2px 0px 7.2px !important;
} */
</style>
